import React from 'react'

function Join() {
  return (
   <>
   <section id="join">
    <div className="container">
        <div className="row">
            <div className="col-md-12">
                <h1 className='display-1 text-center'>JOIN US VIA</h1>
                <h1 className='display-1 text-center heading-2'>Discord</h1>
                <p className='text-center'>Invest and manage all your crypto at one place.</p>
                <button className='join-btn'>Join via Discord</button>
            </div>
        </div>
    </div>
   </section>
   </>
  )
}

export default Join